import { httpHandler } from '../httpHandler';

const URI =  '/w/seller/me'

export const get = () => httpHandler.get({url: URI});
export const put = (body) =>
  httpHandler.put({ url: URI, options: { body } })
